// GERADO POR scripts/build-icons.js — não edite à mão.
// Fonte: handoff/assets/icons/sneaker.svg

import React from 'react';

/** Proporção nativa 24x24. */
export default function IconeSneaker({ size = 24, color = 'currentColor', strokeWidth, className, title, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth ?? 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3 6.5V18a1 1 0 0 0 1 1h16.5a1.5 1.5 0 0 0 1.5-1.5V17a3 3 0 0 0-2.3-2.9l-4.2-1.1L11 7.5 8.8 9a2 2 0 0 1-2.5-.4L4.7 6.1A1 1 0 0 0 3 6.5z"></path><path d="M3 15.5h17.6"></path><path d="M12.5 9.3l-1.2 1"></path><path d="M14 11.1l-1.2 1"></path>
    </svg>
  );
}
